import jwt from "jwt-decode";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { checkValidToken } from "../api/Auth";
import awsExports from "../aws-exports";
import UserInfoContext, { UserInfo } from "./UserInfoContext";

function buildUserInfoFromToken(accessToken: string): UserInfo {
  const decodedToken: any = jwt(accessToken);
  const email = decodedToken["email"];
  const userId = decodedToken["sub"];
  const groupsRaw = decodedToken["cognito:groups"];
  const groups = Array.isArray(groupsRaw)
    ? groupsRaw
    : groupsRaw
    ? [groupsRaw]
    : [];

  return {
    userId,
    accessToken,
    email,
    groups,
    isAdmin: groups.includes("admin"),
  };
}

export function UserInfoContextProvider() {
  const [userInfo, setUserInfo] = useState<UserInfo>();
  const [render, setRender] = useState<Boolean>(false);

  useEffect(() => {
    const lastAuthUser = localStorage.getItem(
      `CognitoIdentityServiceProvider.${awsExports.USER_POOL_APP_CLIENT_ID}.LastAuthUser`
    );
    if (lastAuthUser) {
      const accessToken = localStorage.getItem(
        `CognitoIdentityServiceProvider.${awsExports.USER_POOL_APP_CLIENT_ID}.${lastAuthUser}.idToken`
      );
      if (accessToken && checkValidToken(accessToken)) {
        setUserInfo(buildUserInfoFromToken(accessToken));
      }
    }
    setRender(true);
  }, []);

  const updateUserInfo = (newValue: UserInfo) => {
    setUserInfo(newValue);
  };

  return (
    <UserInfoContext.Provider value={{ userInfo, updateUserInfo }}>
      {render && <Outlet />}
    </UserInfoContext.Provider>
  );
}
